import React, { useState, useEffect } from "react";
import api from "../utils/axiosInstance.js";
import LoadingScreen from "../components/LoadingScreen.jsx";
import functionConstants from "../utils/functionConstants.js";
import pageConstants from "./pageConstants.js";

const UsrAuth = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [functionId, setFunctionId] = useState(null);
  useEffect(() => {
    const apiCall = async () => {
      try {
        const response = await api.post("/authentication/protected");
        if (!response.data.errorCode && localStorage.getItem("functionId")) {
          setFunctionId(response.data.functionId);
        } else {
          localStorage.clear();
          window.location.href = "/login";
        }
      } catch (error) {
        console.error(error);
        localStorage.clear();
        window.location.href = "/login";
      }
      setLoading(false);
    };

    const minimumDelay = 60;
    const apiCallTimeout = setTimeout(() => {
      apiCall();
    }, minimumDelay);

    return () => clearTimeout(apiCallTimeout);
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  var checkPrivatePage = false;
  // if (
  //   children.type.name === "BrokerComPage" ||
  //   children.type.name === "CategoriesPage" ||
  //   children.type.name === "SubCategoriesPage" ||
  //   children.type.name === "EventCalendarPage" ||
  //   children.type.name === "QuickLinksPage" ||
  //   children.type.name === "CreateCampaignPage" ||
  //   children.type.name === "EditCampaignPage" ||
  //   children.type.name === "CreateDocCenterPage" ||
  //   children.type.name === "EditDocumentPage"
  // ) {
  //   checkPrivatePage = true;
  // }

  var landing = false;
  var camapign = false;
  var docCenter = false;
  var brokerCom = false;
  var categories = false;
  var subCategories = false;
  var eventCalendar = false;
  var quickLink = false;
  var createCampaign = false;
  var createDocCenter = false;
  var editCampaign = false;
  var editDocCenter = false;
  var viewDocCenter = false;
  var campaignDetail = false;
  const functionList = String(functionId).split(",");

  if (
    localStorage.getItem("ifa") === "null" &&
    functionList.includes(String(functionConstants.DOCUMENT_CENTER_VIEW))
  ) {
    landing = true;
  }

  //check campaign
  if (
    functionList.includes(
      String(functionConstants.CAMPAIGN_HEADER_BDELIGHT_VIEW)
    ) ||
    functionList.includes(
      String(functionConstants.CAMPAIGN_HEADER_CICONV_VIEW)
    ) ||
    functionList.includes(
      String(functionConstants.CAMPAIGN_HEADER_KDOLLAR_VIEW)
    )
  ) {
    camapign = true;
    campaignDetail = true;
  }

  //check docCenter
  if (functionList.includes(String(functionConstants.DOCUMENT_CENTER_VIEW))) {
    docCenter = true;
    viewDocCenter = true;
  }

  //check docCenter
  if (
    functionList.includes(
      String(functionConstants.CMS_BROKER_COMMUNICATION_ADD)
    )
  ) {
    brokerCom = true;
  }

  //check categories & subCategories
  if (functionList.includes(String(functionConstants.CMS_CATEGORIES_ADD))) {
    categories = true;
    subCategories = true;
  }

  //check eventCalendar
  if (functionList.includes(String(functionConstants.CMS_EVENT_CALENDAR_ADD))) {
    eventCalendar = true;
  }

  //check quicklink
  if (functionList.includes(String(functionConstants.CMS_QUICK_LINKS_ADD))) {
    quickLink = true;
  }

  //check createCampaign & editCampaign
  if (
    functionList.includes(
      String(functionConstants.CAMPAIGN_HEADER_BDELIGHT_CREATE) ||
        String(functionConstants.CAMPAIGN_HEADER_CICONV_CREATE) ||
        String(functionConstants.CAMPAIGN_HEADER_KDOLLAR_APPROVE)
    )
  ) {
    createCampaign = true;
    editCampaign = true;
  }

  //check createCampaign
  if (functionList.includes(String(functionConstants.DOCUMENT_CENTER_UPLOAD))) {
    createDocCenter = true;
  }

  //check editCampaign
  if (functionList.includes(String(functionConstants.DOCUMENT_CENTER_EDIT))) {
    editDocCenter = true;
  }

  if (children.type.name === pageConstants.LandingPage && landing) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.CampaignPage && camapign) {
    checkPrivatePage = true;
  }

  if (
    children.type.name === pageConstants.CampaignDetailPage &&
    campaignDetail
  ) {
    checkPrivatePage = true;
  }

  if (
    children.type.name === pageConstants.CreateCampaignPage &&
    createCampaign
  ) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.EditCampaignPage && editCampaign) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.DocCenterPage && docCenter) {
    checkPrivatePage = true;
  }

  if (
    children.type.name === pageConstants.CreateDocCenterPage &&
    createDocCenter
  ) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.EditDocumentPage && editDocCenter) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.ViewDocumentPage && viewDocCenter) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.QuickLinksPage && quickLink) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.EventCalendarPage && eventCalendar) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.CategoriesPage && categories) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.SubCategoriesPage && subCategories) {
    checkPrivatePage = true;
  }

  if (children.type.name === pageConstants.BrokerComPage && brokerCom) {
    checkPrivatePage = true;
  }

  if (checkPrivatePage) {
    return children;
  } else {
    localStorage.clear();
    window.location.href = "/login";
  }
};

export default UsrAuth;
